import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CONST_AWS_API, DEFAULT_IMAGE } from 'src/app/core/constants';
import { environment } from 'src/environments/environment';
import { API } from 'aws-amplify';
import { UserService } from 'src/app/core/services/user.service';
import { filter, observable, Subscription } from 'rxjs';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { AppService } from 'src/app/core/services/app.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { StorageService } from '../../../../core/services/storage.service';
// import { ThrowStmt } from '@angular/compiler';
import { ToastrService } from 'ngx-toastr';
import { faThumbsDown } from '@fortawesome/free-solid-svg-icons';
import { UtilityService } from 'src/app/core/services/utility.service';
declare let $: any;
@Component({
  selector: 'app-merch-market',
  templateUrl: './merch-market.component.html',
  styleUrls: ['./merch-market.component.scss']
})
export class MerchMarketComponent implements OnInit {
  public isBlue = false;
  colors: boolean[];

  sortBy: any = [{ name: 'Recently Added', value: { 'field': 'date_added', 'order': 'desc' } }, { name: 'Most Viewed', value: { 'field': 'views', 'order': 'desc' } },];
  getCurrency: any;
  getCurrencyType: any;
  currencyInfoSubscription: Subscription;
  currentLocation: {};
  stockData = { "name": 'stock', value: 1 }

  categoryList: any = []
  brandProductsList = [];
  overallFilter: any = []
  allOrgFeatures: any[];
  merchandiseOrganizations: any[];
  constructor(private router: Router, private userService: UserService, private commanService: CommanSubscribeService, private appService: AppService, private ngxLoader: NgxUiLoaderService, public toaster: ToastrService, private storageService: StorageService, private utilityService: UtilityService) { }

  async ngOnInit() {
    this.storageService.deleteItem("product_info");
    this.getFilterData("loadpage");
    $('#DD').on('hide.bs.dropdown', function (e) {
      if (e.clickEvent) {
        e.preventDefault();
      }
    })
    this.allOrgFeatures = await this.utilityService.loadAllOrganizationFeaturesByFeature("merchandise");
    this.merchandiseOrganizations = this.allOrgFeatures
  .filter((org: any) => org.dataStatus === "A")
  .map((org: any) => org.orgId);
  console.log("this.merchandiseOrganizations",this.merchandiseOrganizations);
    let locInfo = this.commanService.locationInfo;
    this.currentLocation = locInfo && Object.keys(locInfo).length > 0 ? locInfo : this.storageService.getItem('current_location');
    if (!this.currentLocation || Object.keys(this.currentLocation).length == 0) {
      this.commanService.getCurrentLocation((val: any, json: any) => {
        console.log(json);
        if (val == "fail") {
          this.currentLocation = {};
        } else {
          this.currentLocation = json;
        }
        this.getCurrency = this.getCurrency ? this.getCurrency : this.currentLocation["currency"]["code"];
        console.log('thi.getcurrency', this.getCurrency)
      });
    } else if(this.currentLocation && Object.keys(this.currentLocation).length > 0){
      this.getCurrency = this.getCurrency ? this.getCurrency : this.currentLocation["currency"]["code"];
    }
    this.currencyInfoSubscription = this.commanService.getCurrencyInfo().subscribe(response => {
      if (response) {
        this.getCurrency = this.storageService.getItem('currency');
        console.log('thi.getcurrency', this.getCurrency)
        this.getFilterData('loadpage');
        // this.getSubscriptionList();
      }
    });
    this.getCurrency = this.getCurrency ? this.getCurrency : this.storageService.getItem('currency');
  }

  getProduct(id,orgId, channelName,networkGroupId?, groupSlug?) {
    (window as any).umami?.track(`Collection ${id} clicked`);
    const u_payload = {
      actionType: "marketplace",
      metaData: {
        title: `Collection11 ${id} clicked`,
        collectionId: id,
        orgId: orgId,
        timeStamp: new Date().toISOString()
      },
      organizationId: orgId || null,
      networkGroupId: networkGroupId || this.commanService.activeGroupId || null,
      clickAction: `marketplace`
    }
    console.log("u_payload",u_payload);
    this.commanService.sendTriggeredEvent(u_payload);
    // Collections can belong to a group; keep it in the URL so the fan lands on the group's page.
    const base = groupSlug ? `/${channelName}/${groupSlug}` : `/${channelName}`;
    this.router.navigate([base + '/merchandise/product-marketplace/' + id]);

  }
  // API call to get collections from start ->stating to limt -> to get no of data from response
  userInfo: any;
  start = 0;
  found = 0;
  price: any = []
  getOverallFilter(response) {
    console.log(response, "getcategorylistdata1")
    this.overallFilter = [];
    if (response.data?.aggregations) {
      Object.entries(response.data?.aggregations).forEach((data: any) => {
        let newdata = { 'name': '', 'value': {} }
        if (data[0] == "network" && data[1].buckets.length > 0) {
          data[1].buckets.forEach(el => {
            if (this.filterArray.length > 0) {
              this.filterArray.forEach(element => {
                if (element.name == data[0] && element.value) {
                  el.fillter = true;
                }
              });
            }
            else {
              el.fillter = false;
            }
          });
          newdata.name = data[0];
          newdata.value = data[1];
          this.overallFilter.push(newdata);
        }
        else if (data[0] == "discount" && data[1].buckets.length > 0) {
          data[1].buckets.forEach(el => {
            if (this.filterArray.length > 0) {
              this.filterArray.forEach(element => {
                if (element.name == data[0] && element.value) {
                  el.fillter = true;
                }
              });
            }
            else {
              el.fillter = false;
            }
          });
          newdata.name = data[0];
          newdata.value = data[1];
          this.overallFilter.push(newdata);
        }
        else if (data[0] == "price" && data[1].buckets.values.length > 0) {
          this.price = []
          data[1].buckets.values.forEach(el => {
            console.log(el, el.value, "price")
            this.price.push(el)
          });
          newdata.name = data[0];
          newdata.value = data[1];
          this.mininput = Math.min.apply(null, this.price) == 0 ? 1 : Math.min.apply(null, this.price);
          this.maxinput = Math.max.apply(null, this.price) == 0 ? 1 : Math.max.apply(null, this.price);
          // this.priceValues();
          // this.overallFilter.push(newdata);
        }
      });
    }

    // console.log(this.filterArray, 'filter', this.price, "Price", Math.max.apply(null, this.price), Math.min.apply(null, this.price))
  }
  //  get data when Scrolled  to bottom
  entredapi: boolean = false;
  onScrollDown() {
    this.entredapi = true;
    // you're at the bottom of the page
    if (this.found != this.brandProductsList.length) {
      this.start += 8;
      this.ngxLoader.start()
      this.getFilterData("getnext");
    }
    else {
      this.ngxLoader.stop();
      this.entredapi = false;
      // this.toaster.success("End of Data");
    }
  }
  scrollheader(data) {
    let scrol = document.getElementById('categoryBtns');
    if (data == 'left') {
      scrol.scrollLeft = scrol.scrollLeft - (scrol.offsetWidth / 2);
    }
    else {
      scrol.scrollLeft = scrol.scrollLeft + (scrol.offsetWidth / 2);
    }
  }

  CollectionFilter = []
  filterArray: any = [];
  dumArray: any = []

  getFilter(colleciton, from?, parentCollection?) {
    
    if (from == "category") {
      const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
      (window as any).umami?.track(`Category ${colleciton.value} Clicked - ${userId}`)
      const data = {
        actionType: "product",
        metaData: {
          title: `Category "${colleciton.value}" Clicked`,
          timeStamp: new Date().toISOString()
          
        },
        organizationId: this.commanService?.slugInfo?.organization_id || null,
        networkGroupId: this.commanService.activeGroupId || null,
        clickAction: `product`
      }
      this.commanService.sendTriggeredEvent(data);
      // this.CollectionFilter = [];
      this.filterArray = [];
      this.dumArray = [];
      this.range = {};
      this.mininput = '';
      this.maxinput = '';
      this.selectedDiscount = '';
      this.overallFilter.forEach(fil => {
        fil.value.buckets.forEach(fildata => {
          fildata.fillter = false;
        });
      })
      this.overallFilter = [];
      this.query = '';
      // this.sortData = {};
      if (this.categoryList.length > 0) {
        this.categoryList.forEach(c => {
          let newda = (this.CollectionFilter.filter(n => n.value == colleciton.value).length);
          if (c.value == colleciton.value && newda == 0) {
            c.fillter = true;
            this.CollectionFilter.push(c);
          }
          else if (c.value == colleciton.value && newda > 0) {
            c.fillter = false;
            this.CollectionFilter = this.CollectionFilter.filter(n => n.value != colleciton.value);
          }
        })
      }
      console.log(this.CollectionFilter, "getcategorylistdata>>>>")
      console.log(this.categoryList, "getcategorylistdata>>>>")
      this.getFilterData(from);
    }
    if (from == 'filter') {
      if (this.overallFilter.length > 0) {
        // this.dumArray = []
        this.overallFilter.forEach(fil => {
          if (fil.name == parentCollection) {
            fil.value.buckets.forEach(fildata => {
              if (fildata.value == colleciton.value && !fildata.fillter) {
                fildata.fillter = true;
                let ndata = this.dumArray.filter(ar => ar.value == colleciton.value)
                if (ndata.length == 0) {
                  this.dumArray.push({ 'name': parentCollection, 'value': colleciton.value });
                }
              }
              else {
                fildata.fillter = false;
              }
            });
          }
        })
      }
      this.applyfilter();
    }
  }
  
  query: any = '';
  netClear: boolean = false;
  priceClear: boolean = false;
  disClear: boolean = false;
  // Calling api for fillter data or cliing collection;
  getFilterData(from?) {
    this.ngxLoader.start()
    this.userInfo = this.commanService.userInfo;
    
    let filterData = [];
    if (from != 'getnext') {
      this.start = 0;
    }
    filterData = this.getFilterSearch();

    // filterData.push({ "name": 'network', "value": 'Nandu' })
    let url = "marketSearch";
    this.range = {};
    let body = {
      "type": "collection",
      "filters": filterData,
      'q': this.query,
      start: this.start,
      "sort": this.sortData,
      // "range": {},
      "currency": this.getCurrency ? this.getCurrency : this.storageService.getItem('currency'),
      limit: 16
    }
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: body
    }
    API.post(environment.AWS_Cognito.apiName, url, myInit).then(res => {
      let response:any = {};
      response.data = res.data.body;
      if (response.data.hits.hits) {
        this.ngxLoader.stop();
        if (this.sortName.length == 0) {
          this.sortbyfilter({ 'field': 'date_added', 'order': 'desc' }, 'Recently Added');
        }
        if (from == 'loadpage') {
          this.categoryList = response.data.aggregations.category.buckets.map(bucket => ({...bucket, value: bucket.key}));
        }
        this.found = response.data.hits.total?.value;
        if (from != 'getnext') {
          this.brandProductsList = response.data.hits.hits || [];
        }
        else {
          response.data.hits.hits.forEach(element => {
            this.brandProductsList.push(element)
          });
        }
        // this.disountFun(response);
        this.brandProductsList = this.brandProductsList.filter((brand: any) => this.merchandiseOrganizations.includes(brand._source.organization_id));
        this.getOverallFilter(response);
        // this.priceClear = body.range && body.range.length > 0 ? true : false;
        let netfill = filterData.filter(a => a.name == 'network');
        let Disfill = filterData.filter(a => a.name == 'discount');
        this.netClear = netfill && netfill.length > 0 ? true : false;
        this.disClear = Disfill && Disfill.length > 0 ? true : false;
        this.overallFilter.forEach(element => {
          if (element.name == "network") {
            element.showfilter = this.netClear;
          }
          else if (element.name == "discount") {
            element.showfilter = this.disClear;
          }
        });
        console.log(this.overallFilter, "overAllfilter1")
        this.ngxLoader.stop();
      }

      this.entredapi = false;
    }).catch(error => {
    });


  }
  getFilterSearch() {
    let filterData = [];
    filterData.push(this.stockData);
    let Obj = { "name": 'category', "value": [] };
    this.categoryList.forEach(data => {
      if (data.fillter) {
        Obj.value.push(data.value);
      }
    })
    if (Obj.value && Obj.value.length > 0) {
      filterData.push(Obj);
    }
    if (this.filterArray.length > 0) {
      this.filterArray.forEach(data => {
        filterData.push(data);
      })
    }
    console.log(this.categoryList, this.selectedDiscount, "this.selectedDiscount0")
    if (this.selectedDiscount != '' && this.discountfilter.value != '') {
      console.log(this.selectedDiscount, "this.selectedDiscount1")
      filterData.push(this.discountfilter)
    }

    return filterData;

  }

  applyfilter(from?) {
    // this.sortData;
    if (from) {
      this.dumArray = [];
      this.sortData = {};
      this.range = {};
      this.selectedDiscount = '';
      this.overallFilter.forEach(fil => {
        fil.value.buckets.forEach(fildata => {
          fildata.fillter = false;
        });
      })

    }
    this.filterArray = this.dumArray;
    this.getFilterData();

  }

  sortData: any = {};
  sortName = "";
  sortbyfilter(data: any, sortName?) {
    this.sortName = sortName
    this.sortData = data;
    this.getFilterData('sort')
  }
  getstock() {
    if (this.stockData.value == 1) {
      this.stockData.value = 0;
      let element = document.getElementById('stockButton');
    }
    else {
      this.stockData.value = 1;
    }
    this.getFilterData('stock')
  }
  closeFilter() {
    $('#getingFilter').removeClass("show");
  }
  // Price Max and min
  mininput: any = '';
  maxinput: any = '';
  minerror: boolean = false;
  maxerror: boolean = false;
  minmessage = "";
  maxmessage = "";
  range: any = []
  priceValues(from?) {
    this.range = {};
    if (from == 'min') {
      if (this.mininput < Math.min.apply(null, this.price) && this.mininput != '') {
        this.minerror = true;
        this.minmessage = "Min value is " + Math.min.apply(null, this.price);
      }
      else if (this.mininput >= Math.max.apply(null, this.price) && this.mininput != '') {
        this.minerror = true;
        this.minmessage = "Min value cannot be greater or equal to " + Math.max.apply(null, this.price)
      }
      else {
        this.minerror = false;
        this.minmessage = "";
      }
    }
    if (from == 'max') {
      if (this.maxinput > Math.max.apply(null, this.price)) {
        this.maxerror = true;
        this.maxmessage = "Max value is " + Math.max.apply(null, this.price);
      }
      else if (this.maxinput < this.mininput && this.maxinput != '') {
        this.maxerror = true;
        this.maxmessage = "maxmimum value cannot be less than minimum value";
      }
      else {
        this.maxerror = false;
        this.maxmessage = '';
      }
    }
    let n = { "field": "price", "min": Number(this.mininput), "max": Number(this.maxinput) }
    if (this.mininput && this.maxinput && this.mininput <= this.maxinput && this.maxinput >= this.mininput) {
      this.range.push(n);
    }
    else {
      this.range = [];
    }
    if (from == 'price') {
      this.getFilterData("price");
    }
  }
  selectedDiscount: any = ''
  discountfilter = { name: 'discount', value: '' }
  disountFun(data) {
    if (data == '1') {
      if (this.selectedDiscount == '' || this.selectedDiscount == '0') {
        this.selectedDiscount = '1';
      }
      else {
        this.selectedDiscount = '';
      }
    }
    else if (data == '0') {
      if (this.selectedDiscount == '' || this.selectedDiscount == '1') {
        this.selectedDiscount = '0';
      }
      else {
        this.selectedDiscount = '';
      }
    }
    this.discountfilter.value = this.selectedDiscount;
    // if (this.selectedDiscount != '') {
    this.getFilterData('discount')
    // }
  }
  cleraFilter(data) {
    if (data == 'network') {
      // this.filterArray = [];
      // this.dumArray = [];
      this.overallFilter.forEach(fil => {
        this.filterArray = this.filterArray.filter(data => data.name != 'network');
        this.dumArray = this.filterArray.filter(data => data.name != 'network');
        console.log(fil, "fil")
        if (fil.name == 'network') {
          fil.value.buckets.forEach(fildata => {
            console.warn(fildata, "filldata")
            fildata.fillter = false;
          });
        }
      })
    }
    else if (data == 'discount') {
      // this.filterArray = [];
      // this.dumArray = [];
      this.overallFilter.forEach(fil => {
        this.filterArray = this.filterArray.filter(data => data.name != 'discount');
        this.dumArray = this.filterArray.filter(data => data.name != 'discount');
        console.log(fil, "fil")
        if (fil.name == 'discount') {
          fil.value.buckets.forEach(fildata => {
            console.warn(fildata, "filldata")
            fildata.fillter = false;
          });
        }
      })
    }
    else if (data == 'price') {
      this.range = [];
      this.mininput = '';
      this.maxinput = ''
    }
    else if (data == 'discount') {
      this.selectedDiscount = '';
      this.discountfilter.value = '';
    }
    this.getFilterData('clearfilter');

  }


  toggleTrue(id: number) {
    this.colors[id] = !this.colors[id];
  }
  public toggleButtonClass(name) {
    if (name) {
      this.isBlue = !this.isBlue;
    }
  }
  trackFinalSearch() {
    const cleanQuery = this.query?.trim();
    if (!cleanQuery) return;
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Searched in Merchandise - "${this.query.trim()}" - ${userId}`);
    const data = {
      actionType: "product",
      metaData: {
        title: `Searched in Merchandise - "${this.query.trim()}`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.commanService?.slugInfo?.organization_id || null,
      networkGroupId: this.commanService.activeGroupId || null,
    }
    this.commanService.sendTriggeredEvent(data);
  }
}

